var _linearGradient, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBar10024326(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 43.93,
    x2: 468.07,
    y1: 43.93,
    y2: 468.07
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2492ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043ae"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_51",
    "data-name": 51
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "url(#linear-gradient)",
    height: 512,
    rx: 150,
    width: 512
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 161h-300c-13.81 0-25-11.19-25-25 0-13.81 11.19-25 25-25h300c13.81 0 25 11.19 25 25 0 13.81-11.19 25-25 25zm0 70h-300c-13.81 0-25 11.19-25 25 0 13.81 11.19 25 25 25h300c13.81 0 25-11.19 25-25 0-13.81-11.19-25-25-25zm0 120h-300c-13.81 0-25 11.19-25 25 0 13.81 11.19 25 25 25h300c13.81 0 25-11.19 25-25 0-13.81-11.19-25-25-25z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBar10024326);
export default __webpack_public_path__ + "static/media/menu-bar_10024326.708dea7930aa310f8786aa29c0343822.svg";
export { ForwardRef as ReactComponent };